module.exports = __webpack_public_path__ + "media/images/RightArrowImage-55e273b1.png";